function Title({ children, className }) {
  return <p className={className}>{children}</p>;
}

export default Title;
